module.exports = __webpack_public_path__ + "img/12.24d89d94.png";